export default [
    {
        name: 'DienstplanArchive',
        import: function () { return import('./Archive'); },
    },
    {
        name: 'DienstplanSingle',
        import: function () { return import('./Single'); },
    },
    {
        name: 'DienstplanHeaderIdentity',
        import: function () { return import('./HeaderIdentity'); },
    },
];
